const TEXT = {
    BANK_CONTENT_TEXT_1:"常用银行卡",
    BANK_CONTENT_TEXT_2:"删除",
    BANK_CONTENT_TEXT_3:"添加银行卡",
    BANK_CONTENT_TEXT_4:"银行卡新增",
    BANK_CONTENT_TEXT_5:"开户人姓名",
    BANK_CONTENT_TEXT_6:"请输入开户人姓名",
    BANK_CONTENT_TEXT_7:"银行卡账号",
    BANK_CONTENT_TEXT_8:"输入银行卡账号",
    BANK_CONTENT_TEXT_9:"开户行名称",
    BANK_CONTENT_TEXT_10:"请输入开户行名称",
    BANK_CONTENT_TEXT_11:"保存",
    BANK_CONTENT_TEXT_12:"收款账号",
    BANK_CONTENT_TEXT_13:"添加微信收款账户",
    BANK_CONTENT_TEXT_14:"添加支付宝收款账户",
    BANK_CONTENT_TEXT_15:"添加银行卡收款账户",
    BANK_CONTENT_TEXT_16:"管理支付宝账号",
    BANK_CONTENT_TEXT_17:"开户行地址",
    BANK_CONTENT_TEXT_18:"请输入开户行地址",
    BANK_CONTENT_TEXT_19:"开户网点",
    BANK_CONTENT_TEXT_20:"请输入开户行网点",
    BANK_CONTENT_TEXT_21:"管理支付宝账号",
    BANK_CONTENT_TEXT_22:"添加支付宝账号",
    BANK_CONTENT_TEXT_23:"姓名",
    BANK_CONTENT_TEXT_24:"请输入姓名",
    BANK_CONTENT_TEXT_25:"账号",
    BANK_CONTENT_TEXT_26:"请输入账号",
    BANK_CONTENT_TEXT_27:"管理微信账号",
    BANK_CONTENT_TEXT_28:"添加微信账号",
    BANK_CONTENT_TEXT_29:"用户名",
    BANK_CONTENT_TEXT_30:"请输入用户名",
    BANK_CONTENT_TEXT_31:"微信收款二维码",
    BANK_CONTENT_TEXT_32:"确认添加",

};
export {
	TEXT
}


// WEBPACK FOOTER //
// ./src/config/page/cn/bank/index.js